export enum EmployeeRole {
  Owner = 'owner',
  Admin = 'admin',
  Manager = 'manager',
  Acc_manager = 'acc_manager',
  Support = 'support',
  Viewer = 'viewer',
}

export const EMPLOYEE_ROLE_TITLE: Record<EmployeeRole, string> = {
  [EmployeeRole.Owner]: 'Владелец',
  [EmployeeRole.Admin]: 'Администратор',
  [EmployeeRole.Manager]: 'Менеджер',
  [EmployeeRole.Acc_manager]: 'Аккаунт Менеджер',
  [EmployeeRole.Support]: 'Поддержка',
  [EmployeeRole.Viewer]: 'Просмотр',
};

export enum UserRole {
  God = 'GOD',
  Director = 'director',
  Aml = 'aml',
  Support_line_1 = 'support_line_1',
  Support_line_2 = 'support_line_2',
  Finance_manager = 'finance_manager',
}
